'use strict';
import $ from 'jquery';

export default class Accolades {
    static init() {
        $('section.accolades').each((index, el) => {
            new Accolades($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        let desktopSettings = 'unslick';
        if (this.el.find('.accolades-cards-card').length > 5) {
            desktopSettings = {
                slidesToShow: 5,
                slidesToScroll: 1
            };
        }
        this.el.find('.accolades-cards > div').on('init', () => this.matchHeights());
        this.el.find('.accolades-cards > div').on('afterChange', () => this.matchHeights());
        this.el.find('.accolades-cards > div').slick({
            mobileFirst: true,
            arrows: true,
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            dots: false,
            slidesToShow: 1,
            responsive: [{
                breakpoint: 768,
                settings: desktopSettings
            }]
        });
    }

    matchHeights() {
        this.el.find('.accolades-cards-card > div').matchHeight();
        this.el.find('.accolades-cards-card > div .accolades-cards-card-image').matchHeight();
    }
}